import React, {useContext} from 'react';
import {Card, CardContent, Grid, Paper, Table, TableBody, TableContainer} from "@mui/material";
import PageTitle from "../../../../components/WMS/Mobile/PageTitle";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../components/CustomButton";
import {WMSRoutes} from "../../../../utils/WMSRoutes";
import Header from "./Header";
import ModelItem from "./ModelItem";
import {MissionModelListContext} from "../MissionModelListContext";
import WmsDesktopLayout from "../../wmsDesktopLayout";

function ModelListDesktop(props) {
    const {
        missionModels,
        history
    } = useContext(MissionModelListContext)

    const vhToPx = (vh) => {
        return (window.innerHeight * vh) / 100
    }

    return (
        <WmsDesktopLayout>
            <WmsDesktopLayout.Content>
                <Card sx={{height: '100%'}}>
                    <CardContent>
                        <Grid container direction={'column'} gap={'48px'} sx={{maxHeight: "100%"}}>
                            <Grid container justifyContent={"space-between"} alignContent={"center"}>
                                <Grid item>
                                    <PageTitle
                                        isDesktop={true}
                                        title={<FormattedMessage id={"wms.pickingMissionList.title"}/>}
                                        subtitle={<FormattedMessage id={"wms.pickingMissionList.subtitle"}/>}
                                    />
                                </Grid>

                                <Grid item sx={{marginTop: "8px"}}>
                                    <CustomButton thicker onClick={() => history.push(`${WMSRoutes.NEW_MISSION}`)}>
                                        <FormattedMessage id={"wms.pickingMissionList.redirectButton.newModel"}/>
                                    </CustomButton>
                                </Grid>
                            </Grid>
                            <Paper sx={{width: '100%', overflow: 'hidden'}}>
                                <TableContainer sx={{maxHeight: vhToPx(55)}}>
                                    <Table stickyHeader>
                                        <Header/>
                                        <TableBody>
                                            {missionModels.length > 0 && missionModels.map((missionModel) => {
                                                return (
                                                    <ModelItem
                                                        key={missionModel.id}
                                                        missionModel={missionModel}
                                                    />
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Grid>
                    </CardContent>
                </Card>
            </WmsDesktopLayout.Content>
        </WmsDesktopLayout>
    );
}

export default ModelListDesktop;